module.exports = __webpack_public_path__ + "img/cat_sanofiaventis-small.e638b8cc.png";